import React, {useEffect, useState} from 'react';
import {useCountdownContext} from "src/contexts/countdown-context";
import {Typography} from "@mui/material";
import {Box} from "@mui/system";
import {toast} from "react-hot-toast";
import dayjs from "dayjs";
import {claimService} from "src/api/claim-service";


const Countdown = () => {
    let {
        showCountdown,
        setShowCountdown,
        tempState,
        setTempState,
        notifyCaseID,
        ClearStateCountDown,
        time_count,
        timeLeft,
        setTimeLeft
    } = useCountdownContext();

    const prevTempStateCaseID = React.useRef(null); // Store the previous caseID

    const pad = (value) => {
        return String(value).padStart(2, '0');
    };
    // #1
    useEffect(() => {
        // console.log("tempState",tempState)
        // console.log("#1")
        if (tempState && tempState.caseID !== prevTempStateCaseID.current) {
            setTimeLeft(time_count);
            prevTempStateCaseID.current = tempState.caseID; // Update the previous caseID
        }
    }, [tempState]);

    // #2
    // FIXME check expire
    useEffect(() => {
        const checkingExpire = async () => {
            try {
                console.log("this checkExpire!!!!", dayjs().format('hh:mm:ss'));
                let response = (await claimService.check_confirmcase({caseID: tempState.caseID})).response;
                console.log("response", response)

                if (response) {
                    if (response?.success === true) {
                        await ClearStateCountDown();
                    } else {
                        await ClearStateCountDown();
                        // await setTimeLeft(() => time_count);
                        await toast.remove("countdown-toast");
                    }
                }
            } catch (error) {
                await ClearStateCountDown();
                // await setTimeLeft(() => time_count);
                if (error.response && error.response.status >= 400 && error.response.status < 500) {
                    console.log("4xx Error:", error.response.status);
                } else {
                    // Handle other errors
                }
            }
        };

        const startCountdown = () => {
            if (timeLeft === 0 && showCountdown) {
                checkingExpire().then(() => {
                });
            }
        };


        startCountdown();


        return () => {
            if (timeLeft === 0) {
               return  ClearStateCountDown();
                // setTimeLeft(time_count);
            }
        };
    }, [showCountdown, timeLeft, setShowCountdown, tempState]);

    // #3
    useEffect(() => {
        // console.log("#3")
        if (timeLeft === 0) {
            ClearStateCountDown();
            setTimeLeft(0);
        }
    }, [timeLeft, showCountdown]);


    // #4
    useEffect(() => {
        // console.log("#4")
        let countdownInterval;

        if (showCountdown && tempState !== null && tempState !== '') {
            countdownInterval = setInterval(() => {
                setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : prevTime));
            }, 1000);
        }

        return () => {
            clearInterval(countdownInterval);
            if (timeLeft === 0) {
               return  ClearStateCountDown();
                // setTimeLeft(time_count);
            }
        };
    }, [showCountdown, tempState]);

    if (showCountdown && timeLeft > 0) {
        toast((t) => (
            <Box
                sx={{
                    color: "#000000",
                    textAlign: 'start',
                    position: 'relative',
                    minWidth: '250px'
                }}
            >
                <Box sx={{textAlign: 'center'}}>
                    <Typography fontSize={12} fontWeight={'bolder'}>
                        รอพนักงานรับงานภายใน 1 นาที 30 วินาที
                    </Typography>
                    <Typography fontSize={16} fontWeight={'bolder'} color={'error'}>
                        {`${Math.floor(timeLeft / 60)} นาที ${timeLeft % 60} วินาที`}
                    </Typography>
                </Box>
            </Box>
        ), {
            id: "countdown-toast", // Use ID to update the toast instead of creating a new one
            title: 'Job in progress',
            duration: Infinity,
            position: "top-center",
            style: {
                borderRadius: '10px',
                border: '1px rgba(107, 66, 187, 0.29) solid',
                background: 'rgba(196, 191, 191, 0.29)',
                "&:hover": {
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px"
                },
            },
        });
    } else {
        toast.remove("countdown-toast");
    }
    return null;
};

export default Countdown;
